import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import { GroupSharingActionTypes, GroupSharingActions } from '../actions/group-sharing.actions';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { GroupsService } from '../../../services/groups.service';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class GroupSharingEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private GroupService = inject(GroupsService);
  private injector = inject(Injector);


  constructor() {}

  getGroupShareList$ = createEffect(() => this.actions$.pipe(
    ofType(GroupSharingActionTypes.GetGroupSharingList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const params = {
        otp: user.otp,
        owner_acode: null,
        GroupId: null,
        shared_acode: null,
        RegionIds: null
      };
      if (payload.owner_acode) { params.owner_acode = payload.owner_acode; }
      if (payload.GroupId) { params.GroupId = payload.GroupId; }
      if (payload.shared_acode) { params.shared_acode = payload.shared_acode; }
      if (payload.RegionIds) { params.RegionIds = Array.isArray(payload.RegionIds) ? [...payload.RegionIds] : payload.RegionIds; }
      return this.GroupService.ReadGroupShareInfo(params).pipe(
        switchMap((res) => {
          if (res.result) {
            const result = Array.isArray(res.msg.body) ? res.msg.body : [];
            return [new featureActions.LoadGroupSharingList(result)];
          } else {
            return [new featureActions.GetGroupSharingListFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return [new featureActions.GetGroupSharingListFail()];
        })
      );
    })
  ));
  AddGroupShareList$ = createEffect(() => this.actions$.pipe(
    ofType(GroupSharingActionTypes.AddGroupSharing),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const param = {
        otp: user.otp,
        group_id: payload.objectId,
        owner_acode: user.acode,
        shared_user: payload.shared_user
      };
      return this.GroupService.AddGroupShareInfo(param).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.AddGroupSharingInfo
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddGroupSharingInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  UpdateGroupShareList$ = createEffect(() => this.actions$.pipe(
    ofType(GroupSharingActionTypes.UpdateGroupSharing),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const params = {
        otp: user.otp,
        share_id: payload.share_id,
        is_confirm: payload.is_confirm,
        owner_acode: payload.owner_acode
      };
      return this.GroupService.UpdateGroupShareInfo(params).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.UpdateGroupSharingInfo
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: this.injector.get(TranslateService).instant('Update Failed') })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpdateGroupSharingInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  DeleteGroupShareList$ = createEffect(() => this.actions$.pipe(
    ofType(GroupSharingActionTypes.DeleteGroupSharing),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const params = {
        otp: user.otp,
        share_id: payload.share_id,
        owner_acode: payload.owner_acode,
        group_id: payload.objectId
      };
      return this.GroupService.DeleteGroupShareInfo(params).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.DeleteGroupSharingInfo
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteGroupSharingInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
